import { SelectFormsy, CheckboxFormsy } from '@fuse'
import {
  DialogActions,
  DialogContent,
  Divider as DividerBase,
  Icon,
  IconButton,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { AddressType } from '../constants'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import DescribedMenuItem from 'app/components/DescribedMenuItem'
import effects from 'app/effects/effects'
import clsx from 'clsx'
import { pricePerNoti } from 'commons/number'
import PlanBillingTermAndConditionBeacon from './PlanBillingTermAndConditionBeacon'
import TextLinkToDialogButton from 'app/components/buttons/TextLinkToDialogButton'
import {
  getExpireDatePlanByPlanType,
  getPlanType,
  isPlanFreeTierByPlanId,
  isPlanFreeTrialByPlanId,
  isFreeTierOrFreeTrialPlanByPlanId,
  hasPlanEnded,
  isUpgradePlan,
  isDowngradePlan,
  isPhysicalWebStarterPackByPlanId,
  PlanId,
  RecurringPlanPrice,
} from 'commons/plan'
import useFormState, { actionTypes } from 'commons/useFormState'
import {
  usePlan,
  useSubscription,
  useNotesAvailable,
  hasOverdraftByNotesAvailable,
} from 'commons/useSubscription'
import Formsy from 'formsy-react'
import { isEmptyOrNil } from 'libs/empty'
import { useFetcher } from 'libs/fetcher'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useCallback, useRef, useState } from 'react'
import { formatDate } from 'commons/date'
import { FormattedMessage, useIntl } from 'react-intl'
import appConfigs from 'app/configs/appConfigs'
import {
  useHasStartedGracePeriod,
  useIsPlaceRestricted,
  useIsPlaceExpired,
} from 'commons/useIsPlaceRestricted'

import {
  GroupPlanLabel,
  plansToSelect,
  planDescription,
  SectionPlanId,
} from './PlanBillingChangePlan'
import { parsedPhoneNumber } from 'commons/phoneNumber'
import {
  PlanBillingDetailsForm,
  parsePhoneNumber,
} from './PlanBillingDetailsForm'
import { PlanBillingShippingForm } from './PlanBillingShippingForm'
import PlanBillingPaymentMethodFormsy from './PlanBillingPaymentMethodFormsy'
import { renderPhysicalStarterPackMenuItem } from './PhysicalStarterPackMenuItem'
import PlanPhysicalWebStarterPackInfo from './PlanPhysicalWebStarterPackInfo'
import { openNewTab, termsOfUseUrl } from 'commons/website'

const unableFreeTierPlanFeatures = [
  'multimediaSupport',
  'teamMembers',
  'rolesPermissions',
  'groups',
  'analytics',
  'overdraft',
]

const useStyles = makeStyles((theme) => ({
  link: {
    color: `${theme.palette.secondary.main} !important`,
  },
  formContainer: {
    height: 'calc(100% - 64px)',
  },
  summaryContainer: {
    height: 'calc(100% - 56px)',
  },
  planMenu: {
    '& .MuiMenu-list': {
      overflow: 'auto',
    },
    '& .MuiMenuItem-root': {
      overflow: 'visible',
    },
  },
  tooltipContainer: {
    '&:hover': {
      backgroundColor: theme.palette.billing.menu.disabled.background,
    },
    '& p': {
      color: `${theme.palette.billing.menu.disabled.text} !important`,
    },
    '&:hover .plan-tooltip': {
      lineHeight: 'initial',
      display: 'block !important',
      background: 'rgba(0,0,0,0.7)',
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  closeIcon: {
    right: 15,
    bottom: 15,
  },
}))

const Divider = (props) => {
  return (
    <div className="my-24 h-1">
      <DividerBase className="absolute w-full bg-grey-light" />
    </div>
  )
}

const freeTierPlanOnlyFeatureLabels = [
  'planAndBilling.yourPlan.changePlan.plan.feature.initialInviteEmail',
]

const paidPlanOnlyFeatureLabels = [
  'planAndBilling.yourPlan.changePlan.plan.feature.initialInvite',
]

const featureLabels = [
  'planAndBilling.yourPlan.changePlan.plan.feature.notificationTimeline',
  'planAndBilling.yourPlan.changePlan.plan.feature.profileInfo',
  'planAndBilling.yourPlan.changePlan.plan.feature.subscribers',
  'planAndBilling.yourPlan.changePlan.plan.feature.plansBilling',
  'planAndBilling.yourPlan.changePlan.plan.feature.initialNotification',
  'planAndBilling.yourPlan.changePlan.plan.feature.initialInviteEmail',
  'planAndBilling.yourPlan.changePlan.plan.feature.analytics',
  'planAndBilling.yourPlan.changePlan.plan.feature.groups',
  'planAndBilling.yourPlan.changePlan.plan.feature.multimediaSupport',
  'planAndBilling.yourPlan.changePlan.plan.feature.teamMembers',
  'planAndBilling.yourPlan.changePlan.plan.feature.rolesPermissions',
  'planAndBilling.yourPlan.changePlan.plan.feature.initialInvite',
  'planAndBilling.yourPlan.changePlan.plan.feature.overdraft',
]
export function PlanBillingChangePlanForm({
  initialValue,
  paymentMethod,
  onSubmit,
  onClose,
  planBill,
}) {
  const classes = useStyles()
  const currentPlan = usePlan()
  const notesAvailable = useNotesAvailable()
  const dropinRef = useRef(null)
  const subscription = useSubscription()
  const isPlaceRestricted = useIsPlaceRestricted()
  const isPlaceExpired = useIsPlaceExpired()
  const hasStartedGracePeriod = useHasStartedGracePeriod()
  const [isPaymentMethodRequestable, setIsPaymentMethodRequestable] =
    useState(false)
  const [selectedPlan, setSelectedPlan] = useState({})
  const [isOpenTermAndConditionBeacon, setIsOpenTermAndConditionBeacon] =
    useState()

  const [initial, setInitial] = useState(initialValue)
  const { formatMessage } = useIntl()
  const nextPlan = R.path(['planBill', 'nextSubscription'], planBill)

  const formRef = useRef(null)
  const [formState, dispatch] = useFormState()
  const callSubmit = () => {
    if (!R.isNil(formRef.current)) formRef.current.submit()
  }
  const fetchPlans = useCallback(() => {
    return effects.apis.getPlans()
  }, [])

  const { values: plans, isLoading: isPlansLoading } = useFetcher(fetchPlans, {
    data: [],
  })

  const planOptions = plansToSelect(plans, formatMessage)

  const getPlanByPlanId = (planId) => {
    return R.compose(
      R.find(R.propEq('planId', planId)),
      R.propOr([], 'data'),
    )(plans)
  }

  const getRequestPaymentMethod = async () => {
    if (isPlanFreeTierByPlanId(R.prop('planId', selectedPlan)))
      return Promise.resolve({})
    return dropinRef.current.requestPaymentMethod()
  }

  const handleSubmit = async (value) => {
    dispatch({ type: actionTypes.SUBMIT_INIT })
    try {
      const response = await getRequestPaymentMethod()
      await onSubmit(
        R.mergeAll([
          value,
          {
            paymentMethodNonce: R.prop('nonce', response),
            plan: getPlanByPlanId(R.prop('planId', value)),
            shippingAddress: R.mergeAll([
              formatBillingAddress(value),
              {
                type: AddressType.SHIPPING_ADDRESS,
                id: R.path(['shippingAddress', 'id'], initialValue),
              },
            ]),
          },
          parsePhoneNumber(value), //countryCode, phoneNumber,
          value.isShippingAddressSameAsBillingDetails
            ? formatBillingAddress(value)
            : {},
        ]),
      )
    } finally {
      dispatch({ type: actionTypes.SUBMIT_SUCCESS })
    }
  }

  const isDisabledSubmitButton = () => {
    if (isPlanFreeTierByPlanId(R.prop('planId', selectedPlan))) {
      return R.o(R.not, R.prop('isFormValid'), formState)
    }

    return (
      R.o(R.not, R.prop('isFormValid'), formState) ||
      !isPaymentMethodRequestable
    )
  }

  const handleInvalid = () => {
    dispatch({
      type: actionTypes.INVALID_FORM,
    })
  }

  const handleValid = () => {
    dispatch({
      type: actionTypes.VALID_FORM,
    })
  }

  const handleSameAddress = (value) => {
    if (value.isShippingAddressSameAsBillingDetails) {
      setInitial((prev) => R.mergeAll([prev, formatBillingAddress(value)]))
    } else setInitial((prev) => R.mergeAll([prev, formatBillingAddress()]))
  }

  const handleChangeFormsy = (value) => {
    setSelectedPlan(getPlanByPlanId(R.prop('planId', value)))

    if (isPhysicalWebStarterPackByPlanId(R.prop('planId', selectedPlan)))
      handleSameAddress(value)
  }

  const handleInitialDropin = useCallback((dropin) => {
    dropinRef.current = dropin

    if (dropin.isPaymentMethodRequestable()) {
      // This will be true if you generated the client token
      // with a customer ID and there is a saved payment method
      // available to tokenize with that customer.
      setIsPaymentMethodRequestable(true)
    }

    dropin.on('paymentMethodRequestable', function (event) {
      setIsPaymentMethodRequestable(true)
    })

    dropin.on('noPaymentMethodRequestable', function () {
      setIsPaymentMethodRequestable(false)
    })
  }, [])

  const currentValues = formRef.current ? formRef.current.getModel() : {}

  const isAddressEmptyAndSelectFreeTier =
    R.isEmpty(initialValue.address1) &&
    isPlanFreeTierByPlanId(R.prop('planId', selectedPlan))
  return (
    <div className="flex flex-col md:flex-row md:overflow-hidden">
      <div className="flex flex-col w-full md:w-2/3 md:border-r-1 md:overflow-auto md:border-grey-light">
        <div className="sticky top-0 flex justify-between bg-white z-10">
          <Typography variant="h6" className="px-16 py-16">
            <FormattedMessage id="planAndBilling.yourPlan.changePlan.label" />
          </Typography>
          <IconButton
            disableRipple
            key="close"
            aria-label="Close"
            className={clsx('md:hidden flex')}
            onClick={onClose}
          >
            <Icon>close</Icon>
          </IconButton>
        </div>

        <Formsy
          ref={formRef}
          className={clsx(classes.formContainer, 'flex flex-col')}
          onValid={handleValid}
          onChange={handleChangeFormsy}
          onInvalid={handleInvalid}
          onValidSubmit={handleSubmit}
        >
          <DialogContent className="relative overflow-auto flex-1">
            <Typography className="mb-16">
              <FormattedMessage id="planAndBilling.yourPlan.changePlan.subTitle" />
            </Typography>
            {!isPlansLoading && (
              <SelectFormsy
                className={clsx('w-full')}
                name="planId"
                label={formatMessage({
                  id: 'planAndBilling.yourPlan.changePlan.plan.label',
                })}
                value=""
                variant="outlined"
                validations={{
                  minLength: 1,
                }}
                MenuProps={{
                  className: clsx(classes.planMenu),
                }}
                validationErrors={{
                  minLength: formatMessage({
                    id: 'registerForm.pricingInvalid',
                  }),
                }}
                required
                renderValue={(planId) => {
                  const selectedPlan = R.propOr([], 'data', plans).find(
                    (plan) => plan.planId === planId,
                  )
                  if (!selectedPlan) return
                  return (
                    <div className="flex">
                      <Typography className="font-bold text-blue-primary ltr:pr-8 rtl:pl-8">
                        {selectedPlan.name}
                      </Typography>
                      <Typography>
                        {planDescription(
                          formatMessage,
                          getPlanType(planId),
                          selectedPlan,
                        )}
                      </Typography>
                    </div>
                  )
                }}
              >
                {R.map(
                  R.cond([
                    [
                      R.propEq('type', 'section'),
                      (item) => {
                        if (item.id === SectionPlanId.NEW_PACKAGE) return
                        return (
                          <div key={item.title}>
                            <Typography
                              variant="h6"
                              className="uppercase px-16 py-8"
                            >
                              {item.title}
                            </Typography>
                            {SectionPlanId.CHANGE_TO_FREE_TIER !== item.id && (
                              <Typography
                                className="px-16 pb-8"
                                key={`${item.title}-subTitle`}
                              >
                                <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.section.description" />
                              </Typography>
                            )}
                          </div>
                        )
                      },
                    ],
                    [
                      R.propEq('type', 'group'),
                      (item) => (
                        <Typography
                          className="py-8 px-16  font-bold"
                          variant="subtitle1"
                          color="secondary"
                          key={item.key}
                        >
                          <FormattedMessage
                            id={R.prop(item.title, GroupPlanLabel)}
                          />
                        </Typography>
                      ),
                    ],
                    [
                      R.T,
                      (item) => {
                        const isDisabled = getIsDisabledPlanOption(
                          item,
                          currentPlan,
                          subscription,
                          notesAvailable,
                          hasStartedGracePeriod,
                          nextPlan,
                          isPlaceRestricted,
                          isPlaceExpired,
                        )

                        if (item.id === PlanId.PHYSICAL_WEB_STARTER_PACK) {
                          if (!isShowPhysicalStarterPackPlan(currentPlan))
                            return null

                          return renderPhysicalStarterPackMenuItem({
                            formatMessage,
                            disabled: isPhysicalWebStarterPackByPlanId(
                              R.prop('id', currentPlan),
                            ),
                            plan: getPhysicalStarterPackPlan(plans),
                          })
                        }

                        return (
                          <MenuItem
                            key={item.id}
                            disabled={isDisabled}
                            value={item.id}
                            className={clsx(
                              'ltr:pl-48 rtl:pr-48 flex items-start',
                              {
                                'bg-gray-400': isDisabled,
                              },
                            )}
                          >
                            <PlanItemIcon
                              isUpgradePlan={isUpgradePlan({
                                currentPlan,
                                nextPlan: item,
                                isPlaceExpired,
                              })}
                            />
                            <DescribedMenuItem
                              title={item.title}
                              description={item.description}
                            />
                          </MenuItem>
                        )
                      },
                    ],
                  ]),
                  planOptions,
                )}
              </SelectFormsy>
            )}
            <Divider />
            {isPlanFreeTierByPlanId(R.prop('planId', selectedPlan)) ? (
              <Typography>
                <FormattedMessage id="planAndBilling.yourPlan.changePlan.payment.notRequired" />
              </Typography>
            ) : (
              <PlanBillingPaymentMethodFormsy
                name="paymentMethodNonce"
                onInitialDropin={handleInitialDropin}
              />
            )}
            <PlanBillingShippingAddress
              currentValues={currentValues}
              initialValue={initial}
              formRef={formRef}
            />
            <PlanBillingDetails
              isAddressEmptyAndSelectFreeTier={isAddressEmptyAndSelectFreeTier}
              selectedPlan={selectedPlan}
              currentValues={currentValues}
              initialValue={initial}
              formRef={formRef}
              formatMessage={formatMessage}
            />
          </DialogContent>
          <DialogActions className="hidden md:flex  justify-between px-24 ltr:pr-36 rtl:pl-36">
            <Typography>
              <FormattedMessage
                id="planAndBilling.yourPlan.changePlan.termAndService.label"
                values={{
                  b1: (text) => (
                    <TextLinkToDialogButton
                      onClick={() => openNewTab(termsOfUseUrl)}
                      className={clsx('cursor-pointer', classes.link)}
                      text={text}
                    />
                  ),
                }}
              />
            </Typography>
            <PrimaryButton
              isLoading={R.prop('isSubmitting', formState)}
              labelId="action.next"
              disabled={isDisabledSubmitButton()}
              type="submit"
            />
          </DialogActions>
        </Formsy>
      </div>
      <div className="w-full md:w-1/3 pt-24 relative overflow-auto">
        <div className="flex justify-between pb-24 px-24 relative">
          <Typography variant="h6">
            <FormattedMessage id="planAndBilling.yourPlan.paymentSummary.dialog.title" />
          </Typography>
          <IconButton
            disableRipple
            key="close"
            aria-label="Close"
            className={clsx(
              classes.closeIcon,
              'absolute hidden md:inline-flex',
            )}
            onClick={onClose}
          >
            <Icon>close</Icon>
          </IconButton>
        </div>
        <div
          className={clsx(
            classes.summaryContainer,
            'p-24  md:overflow-auto w-full relative',
          )}
        >
          {R.complement(isEmptyOrNil)(selectedPlan) ? (
            <>
              <Typography className="font-bold">
                <FormattedMessage
                  id={
                    isPlanFreeTierByPlanId(R.prop('planId', selectedPlan))
                      ? 'planAndBilling.yourPlan.changePlan.plan.freeTier'
                      : isUpgradePlan({
                            currentPlan,
                            nextPlan: selectedPlan,
                            isPlaceExpired,
                          })
                        ? 'planAndBilling.yourPlan.changePlan.plan.upgrade'
                        : 'planAndBilling.yourPlan.changePlan.plan.downgrade'
                  }
                  values={{
                    currentPlan: R.prop('name', currentPlan),
                    nextPlan: R.prop('name', selectedPlan),
                  }}
                />
              </Typography>
              <Typography variant="h6" className="mt-12">
                {R.prop('name', selectedPlan)}
              </Typography>
              {isPhysicalWebStarterPackByPlanId(
                R.prop('planId', selectedPlan),
              ) ? (
                <PlanPhysicalWebStarterPackInfo
                  className="mb-12"
                  plan={selectedPlan}
                />
              ) : (
                <Typography className="mt-12">
                  <FormattedMessage
                    id="planAndBilling.yourPlan.changePlan.plan.info.label"
                    values={{
                      numberNotifications: R.prop(
                        'notesQuantity',
                        selectedPlan,
                      ),
                      type: getPlanType(R.prop('planId', selectedPlan)),
                      priceRatio: pricePerNoti(
                        R.prop('price', selectedPlan),
                        R.prop('notesQuantity', selectedPlan),
                      ),
                    }}
                  />
                </Typography>
              )}
              <Typography>
                <FormattedMessage
                  id="planAndBilling.yourPlan.changePlan.recurring.label"
                  values={{
                    type: getPlanType(R.prop('planId', selectedPlan)),
                    price:
                      RecurringPlanPrice[R.prop('planId', selectedPlan)] ||
                      R.prop('price', selectedPlan),
                  }}
                />
              </Typography>
              <Typography className="mt-12">
                <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.term.label" />
              </Typography>
              <Typography variant="subtitle1" className="mb-12" component="p">
                <FormattedMessage
                  id="planAndBilling.yourPlan.changePlan.plan.term.typeSubscription"
                  values={{
                    type: getPlanType(R.prop('planId', selectedPlan)),
                  }}
                />
              </Typography>
              {isDowngradePlan({
                currentPlan,
                nextPlan: selectedPlan,
                isPlaceExpired,
              }) && (
                <Typography className="text-blue-primary">
                  <FormattedMessage
                    id="planBillingNotification.downgrade.label"
                    values={{
                      planName: R.prop('name', selectedPlan),
                      date: formatDate(
                        R.prop('nextBillingDate', subscription) ||
                          R.prop('endsAt', subscription),
                      ),
                    }}
                  />
                </Typography>
              )}
              {isPhysicalWebStarterPackByPlanId(
                R.prop('planId', selectedPlan),
              ) && (
                <>
                  <TextLinkToDialogButton
                    onClick={() => setIsOpenTermAndConditionBeacon(true)}
                    className={clsx('cursor-pointer', classes.link)}
                    text={
                      <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.termAndConditions" />
                    }
                  />
                  <Typography className="mb-16">
                    <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.buyOneGetOneBeacon" />
                  </Typography>
                </>
              )}
              <Typography className="font-bold">
                <FormattedMessage
                  id={
                    isPlanFreeTierByPlanId(R.prop('planId', selectedPlan))
                      ? 'planAndBilling.yourPlan.paymentSummary.freeTier'
                      : 'planAndBilling.yourPlan.paymentSummary.nextDue'
                  }
                  values={{
                    date: getExpireDatePlanByPlanType(
                      getPlanType(R.prop('planId', selectedPlan)),
                      isDowngradePlan({
                        currentPlan,
                        nextPlan: selectedPlan,
                        isPlaceExpired,
                      }) &&
                        (R.prop('nextBillingDate', subscription) ||
                          R.prop('endsAt', subscription)),
                    ),
                  }}
                />
              </Typography>
            </>
          ) : (
            <Typography className="mb-84 mt-24" component="div">
              <FormattedMessage id="planAndBilling.yourPlan.changePlan.pleaseSelectPlan.label" />
            </Typography>
          )}
          <Divider />
          <div className="flex justify-between">
            <Typography className="font-bold">
              <FormattedMessage id="planAndBilling.yourPlan.changePlan.totalBilled.label" />
            </Typography>
            <Typography className="font-bold">
              ${R.propOr(0, 'price', selectedPlan).toLocaleString()}
            </Typography>
          </div>
          <Divider />
          {!isAddressEmptyAndSelectFreeTier &&
            renderFeatureBySelectedPlan(selectedPlan)}
        </div>
        <PlanBillingTermAndConditionBeacon
          isOpen={isOpenTermAndConditionBeacon}
          onClose={() => setIsOpenTermAndConditionBeacon(false)}
        />
      </div>
      <div className="flex md:hidden flex-col sticky bottom-0 z-10 bg-white px-24 py-8">
        <Typography>
          <FormattedMessage
            id="planAndBilling.yourPlan.changePlan.termAndService.label"
            values={{
              b1: (text) => (
                <TextLinkToDialogButton
                  onClick={() => openNewTab(termsOfUseUrl)}
                  className={clsx('cursor-pointer', classes.link)}
                  text={text}
                />
              ),
            }}
          />
        </Typography>
        <div className="flex justify-end">
          <PrimaryButton
            className="w-1/3"
            isLoading={R.prop('isSubmitting', formState)}
            onClick={callSubmit}
            labelId="action.next"
            disabled={isDisabledSubmitButton()}
            type="submit"
          />
        </div>
      </div>
    </div>
  )
}

PlanBillingChangePlanForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValue: PropTypes.object,
}

const filterFeaturesByPlan = (selectedPlan) => (labelId) => {
  if (isPlanFreeTierByPlanId(R.prop('planId', selectedPlan))) {
    return !R.includes(labelId, paidPlanOnlyFeatureLabels)
  }
  return !R.includes(labelId, freeTierPlanOnlyFeatureLabels)
}

const PlanBillingDetails = ({
  isAddressEmptyAndSelectFreeTier,
  selectedPlan,
  currentValues,
  initialValue,
  formRef,
  formatMessage,
}) => {
  if (isAddressEmptyAndSelectFreeTier)
    return renderFreeTierFeature(selectedPlan)
  return (
    <>
      <Divider />
      <Typography>
        <FormattedMessage id="planAndBilling.billingDetails.label" />
      </Typography>
      <CheckboxFormsy
        className={clsx('flex-1', {
          hidden: !isPhysicalWebStarterPackByPlanId(
            R.prop('planId', selectedPlan),
          ),
        })}
        value={false}
        inputProps={{
          'data-testid': 'isShippingAddressSameAsBillingDetailsInput',
        }}
        label={formatMessage({
          id: 'planAndBilling.ShippingAddress.sameBillingDetails.label',
        })}
        name="isShippingAddressSameAsBillingDetails"
        fullWidth
      />
      {R.prop('isShippingAddressSameAsBillingDetails', currentValues) ? null : (
        <PlanBillingDetailsForm
          className={clsx({
            hidden:
              isPhysicalWebStarterPackByPlanId(
                R.prop('planId', selectedPlan),
              ) &&
              R.prop('isShippingAddressSameAsBillingDetails', currentValues),
          })}
          displayTitle={false}
          initialValue={initialValue}
          formRef={formRef}
        />
      )}
    </>
  )
}

function PlanItemIcon({ isUpgradePlan }) {
  return isUpgradePlan ? (
    <Icon className="text-blue-primary text-16 ltr:mr-8 rtl:ml-8 mt-1">
      arrow_upward
    </Icon>
  ) : (
    <Icon className="text-watermelon text-16 ltr:mr-8 rtl:ml-8 mt-1">
      arrow_downward
    </Icon>
  )
}

function formatBillingAddress(value) {
  return {
    firstName: value?.shippingFirstName,
    lastName: value?.shippingLastName,
    address1: value?.shippingAddress1,
    address2: value?.shippingAddress2,
    country: value?.shippingCountry,
    state: value?.shippingState,
    city: value?.shippingCity,
    zipCode: value?.shippingZipCode,
    ...R.defaultTo(
      { phoneNumber: undefined },
      parsedPhoneNumber(value?.shippingPhoneNumber || ''),
    ), //countryCode, phoneNumber,
  }
}

function PlanBillingShippingAddress({ currentValues, initialValue, formRef }) {
  if (!isPhysicalWebStarterPackByPlanId(R.prop('planId', currentValues)))
    return null
  return (
    <>
      <Divider />
      <Typography>
        <FormattedMessage id="planAndBilling.ShippingAddress.label" />
      </Typography>
      <PlanBillingShippingForm initialValue={initialValue} formRef={formRef} />
    </>
  )
}

function getPhysicalStarterPackPlan(plans) {
  return R.propOr([], 'data', plans).find((plan) => {
    return isPhysicalWebStarterPackByPlanId(plan.planId)
  })
}

function isShowPhysicalStarterPackPlan(currentPlan) {
  return (
    isFreeTierOrFreeTrialPlanByPlanId(R.prop('id', currentPlan)) ||
    isPhysicalWebStarterPackByPlanId(R.prop('id', currentPlan))
  )
}

function renderFreeTierFeature(selectedPlan) {
  return (
    R.complement(isEmptyOrNil)(selectedPlan) && (
      <>
        <Typography className="font-bold">
          <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.feature" />
        </Typography>
        <div className={clsx('grid-cols-2 grid gap-4')}>
          {featureLabels
            .filter(filterFeaturesByPlan(selectedPlan))
            .map(featureItem(selectedPlan))}
        </div>
      </>
    )
  )
}

function featureItem(selectedPlan) {
  return (labelId) => {
    return (
      <Typography className="inline-flex items-center mt-2">
        {isPlanFreeTierByPlanId(R.prop('planId', selectedPlan)) ? (
          <Icon
            className={clsx(
              unableFreeTierPlanFeatures.some(R.includes(R.__, labelId))
                ? 'text-red'
                : 'text-blue-dark',
              ' ltr:mr-4 rtl:ml-4',
            )}
          >
            {unableFreeTierPlanFeatures.some(R.includes(R.__, labelId))
              ? 'close'
              : 'check'}
          </Icon>
        ) : (
          <Icon className={'text-blue-dark ltr:mr-4 rtl:ml-4'}>check</Icon>
        )}
        <FormattedMessage id={labelId} />
      </Typography>
    )
  }
}

function renderFeatureBySelectedPlan(selectedPlan) {
  return (
    R.complement(isEmptyOrNil)(selectedPlan) && (
      <>
        <Typography className="font-bold">
          <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.feature" />
        </Typography>
        <div className={clsx('grid-cols-1 grid gap-4')}>
          {featureLabels
            .filter(filterFeaturesByPlan(selectedPlan))
            .map(featureItem(selectedPlan))}
        </div>
      </>
    )
  )
}

function getIsDisabledPlanOption(
  item,
  currentPlan,
  subscription,
  notesAvailable = 0,
  hasStartedGracePeriod,
  nextPlan,
  isPlaceRestricted,
  isPlaceExpired,
) {
  // order of logic is important , please don't change
  if (isPlanFreeTierByPlanId(item.id)) {
    return !(
      isPlanFreeTrialByPlanId(R.prop('id', currentPlan)) &&
      hasPlanEnded({ subscription })
    )
  }

  if (hasStartedGracePeriod) {
    return isPlanFreeTierByPlanId(item.id)
  }

  if (R.prop('endsAt', subscription)) {
    if (!appConfigs.enableDowngradePlan) {
      return isDowngradePlan({
        currentPlan,
        nextPlan: item,
        isPlaceExpired,
      })
    }

    return false
  }

  if (!appConfigs.enableDowngradePlan) {
    return isDowngradePlan({
      currentPlan,
      nextPlan: item,
      isPlaceExpired,
    })
  }

  if (hasOverdraftByNotesAvailable(notesAvailable)) {
    if (item.id === R.prop('id', currentPlan)) return true
    return Math.abs(notesAvailable) > R.prop('notesQuantity', item)
  }

  if (!isEmptyOrNil(nextPlan)) {
    return item.id === R.prop('id', currentPlan)
  }

  return item.id === R.prop('id', currentPlan) && !isPlaceExpired
}
